/**
 * @param selectedLat 
 * @param selectedLng 
 * This function returns an return point results array.
 */ 
var getResultList = (function (selectedLat, selectedLng) {
    var allReturnPointData = globalReturnPointsData;
    // get distance
    function distance(lat1, lon1, lat2, lon2, unit) {
        var radlat1 = Math.PI * lat1/180
        var radlat2 = Math.PI * lat2/180
        var theta = lon1-lon2
        var radtheta = Math.PI * theta/180
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        dist = Math.acos(dist)
        dist = dist * 180/Math.PI
        dist = dist * 60 * 1.1515
        if (unit=="K") { dist = dist * 1.609344 }
        if (unit=="N") { dist = dist * 0.8684 }
        return dist
    }
    // sort function - sort return point data array based on distance to searched location
    // function compare(a,b) {
    //     if (a.cp_distance < b.cp_distance)
    //         return -1;
    //     if (a.cp_distance > b.cp_distance)
    //         return 1;
    //     return 0;
    // }
    function compare(a,b) {
        if (a.cp_realDistance < b.cp_realDistance)
            return -1;
        if (a.cp_realDistance > b.cp_realDistance)
            return 1;
        return 0;
    }
    $('.c-return-point-result--return-points-card-carousel').hide();
    $('.c-home-return-points-cards-section').hide();          
    var returnPointsListWithDistance = [];
    // Add each distance to return point data
    for(var i =0; i< allReturnPointData.length; i++){
        
        var distanceFromCurrent = Math.round(distance(selectedLat, 
                                                        selectedLng, 
                                                        allReturnPointData[i].cp_latitude, 
                                                        allReturnPointData[i].cp_longitude, 
                                                        'K'));
        var realdDistanceFromCurrent = distance(selectedLat, 
                                            selectedLng, 
                                            allReturnPointData[i].cp_latitude, 
                                            allReturnPointData[i].cp_longitude, 
                                            'K');
        allReturnPointData[i].cp_distance = distanceFromCurrent;
        allReturnPointData[i].cp_realDistance = realdDistanceFromCurrent;
        // if(distanceFromCurrent <= 50){
        //     returnPointsListWithDistance.push(allReturnPointData[i]);
        // }
        returnPointsListWithDistance.push(allReturnPointData[i]);
    }
    if(returnPointsListWithDistance.length == 0){
        $('.c-return-point-result-wrapper h1').hide();
        $('.c-search-results-filters').hide();
        $('.c-return-point-result-wrapper .subtitle').text("It doesn't look like there's a return point near " + getParameterByName['locationName'] + ". Please try again.");
        $('.c-return-point-result--return-points-card-carousel').show();
            $('.c-home-return-points-cards-section').show();          

    }else{
        $('.c-return-point-result--return-points-card-carousel').hide();
            $('.c-home-return-points-cards-section').hide();          

    }

    returnPointsListWithDistance.sort(compare);
    return returnPointsListWithDistance;
});
  
export default getResultList;


// WEBPACK FOOTER //
// ./FE-Build/src/js/modules/getResultList.js